import React from 'react';
import Hero from '../components/Hero/Hero';
import StatsSection from '../components/StatsSection/StatsSection';
import FoodGallery from '../components/FoodGallery/FoodGallery';
import Testimonials from '../components/Testimonials/Testimonials';
import WhyChooseUs from '../components/WhyChooseUs/WhyChooseUs';
import CTASection from '../components/CTASection/CTASection';
import styles from './HomePage.module.css';
import { Link } from 'react-router-dom';
import { FaStar, FaUtensils, FaPhoneAlt, FaArrowRight, FaUserTie } from 'react-icons/fa';

const HomePage = () => {
  return (
    <div className={styles.homePage}>
      <Hero />
      
      <StatsSection />

      <section className={styles.quickLinks}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>Explore Our Kitchen</h2>
          <p className={styles.sectionSubtitle}>અમારું રસોડું જુઓ</p>
          <div className={styles.cardsGrid}>
            <Link to="/specials" className={styles.linkCard}>
              <div className={styles.cardIconWrapper}>
                <FaStar className={styles.cardIcon} />
              </div>
              <h3>Special Varieties</h3>
              <p>અનોખી વેરાયટી</p>
              <div className={styles.viewBtn}>
                <span>View</span>
                <FaArrowRight className={styles.arrow} />
              </div>
            </Link>
            
            <Link to="/menu" className={styles.linkCard}>
              <div className={styles.cardIconWrapper}>
                <FaUtensils className={styles.cardIcon} />
              </div>
              <h3>Full Menu</h3>
              <p>સંપૂર્ણ મેનુ</p>
              <div className={styles.viewBtn}>
                <span>View</span>
                <FaArrowRight className={styles.arrow} />
              </div>
            </Link>
            
            <Link to="/about" className={styles.linkCard}>
              <div className={styles.cardIconWrapper}>
                <FaUserTie className={styles.cardIcon} />
              </div>
              <h3>About Us</h3>
              <p>અમારા વિશે</p>
              <div className={styles.viewBtn}>
                <span>View</span>
                <FaArrowRight className={styles.arrow} />
              </div>
            </Link>
            
            <Link to="/contact" className={styles.linkCard}>
              <div className={styles.cardIconWrapper}>
                <FaPhoneAlt className={styles.cardIcon} />
              </div>
              <h3>Contact Now</h3>
              <p>સંપર્ક કરો</p>
              <div className={styles.viewBtn}>
                <span>View</span>
                <FaArrowRight className={styles.arrow} />
              </div>
            </Link>
          </div>
        </div>
      </section>

      <FoodGallery />

      
      <CTASection />
      <WhyChooseUs />


      {/* <Testimonials /> */}

    </div>
  );
};

export default HomePage;
